<template>
  <v-container fluid v-if="productoProp">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        <!-- Encabezado -->
        <v-toolbar flat color="transparent" class="px-0">
          <v-btn icon @click="$router.back()" class="mr-2">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>

          <v-toolbar-title class="text-h5 font-weight-bold">
            Sucursales
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            hide-details
            dense
            clearable
            placeholder="Buscar sucursal..."
            class="mx-2"
            style="max-width: 250px"
          />

          <v-chip color="primary" outlined class="ml-2">
            {{ totalAsignadas }}/{{ totalSucursales }} asignadas
          </v-chip>
        </v-toolbar>

        <!-- Sucursales asignadas -->
        <v-card class="mt-4" elevation="2">
          <v-card-title class="pb-0">
            <span class="text-subtitle-1 font-weight-medium">Asignadas</span>
            <v-spacer></v-spacer>
            <v-chip
              v-if="asignadasFiltradas.length"
              class="ml-2"
              small
              color="secondary"
              outlined
            >
              {{ asignadasFiltradas.length }}
            </v-chip>
          </v-card-title>

          <v-divider />

          <v-card-text class="py-0">
            <v-list dense v-if="asignadasFiltradas.length">
              <v-list-item
                v-for="(sucursal, index) in asignadasFiltradas"
                :key="'asignada-' + sucursal.id"
                two-line
                @click="goToEdit(sucursal)"
              >
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                    {{ sucursal.sucursal.nombre }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Costo: {{ sucursal.precio_costo | convertPesoArg }} –
                    Ganancia: {{ sucursal.ganancia }} %
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-chip small color="green accent-4" dark>
                    {{ sucursal.precio_venta | convertPesoArg }}
                  </v-chip>
                </v-list-item-action>

                <v-list-item-action>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="error"
                        v-on="on"
                        @click.stop="desAsignarProductoSucursal(sucursal)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>Desasignar</span>
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>

              <!-- opcional: agregar divisores entre ítems -->
              <!-- si querés separadores visuales, los podés incluir directamente en el loop -->
            </v-list>

            <!-- Estado vacío inicial -->
            <p
              v-if="!asignadasFiltradas.length && !search"
              class="grey--text text--caption text-center my-4"
            >
              No compartido con otras sucursales
            </p>
          </v-card-text>
        </v-card>

        <!-- Sucursales NO asignadas -->
        <v-card class="mt-6" elevation="2">
          <v-card-title class="pb-0">
            <span class="text-subtitle-1 font-weight-medium">No asignadas</span>
            <v-spacer></v-spacer>
            <v-chip
              v-if="noAsignadasFiltradas.length"
              class="ml-2"
              small
              color="secondary"
              outlined
            >
              {{ noAsignadasFiltradas.length }}
            </v-chip>
          </v-card-title>

          <v-divider />

          <v-card-text class="py-0">
            <v-list dense v-if="noAsignadasFiltradas.length">
              <v-list-item
                v-for="(sucursal, index) in noAsignadasFiltradas"
                :key="index"
                two-line
                @click="goToEdit(sucursal)"
              >
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                    {{ sucursal.nombre }}
                  </v-list-item-title>
                </v-list-item-content>

               

                <v-list-item-action>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                        @click.stop="asignarProductoSucursal(sucursal)"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Asignar</span>
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>

              <v-divider
                v-if="index < noAsignadasFiltradas.length - 1"
                :key="'divider-' + sucursal.id"
              />
              <v-list-item v-if="!noAsignadasFiltradas.length && search">
                <v-list-item-content>
                  <v-list-item-title classv="grey--text text--caption">
                    Sin coincidencias en no asignadas
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <p
              v-if="!noAsignadasFiltradas.length && !search"
              class="grey--text text--caption text-center my-4"
            >
              Todas las sucursales están asignadas
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

  <!-- Skeleton de carga -->
  <v-container v-else>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-skeleton-loader type="list-item-three-line" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ProductosAPI from "@/api/productos";
export default {
  name: "ProductoSucursalAsignacion",
  props: {
    productoProp: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      search: "",
    };
  },
  computed: {
    asignadas() {
      return this.productoProp?.sucursales_compartidas || [];
    },
    noAsignadas() {
      return this.productoProp?.sucursales_no_compartidas || [];
    },
    asignadasFiltradas() {
      if (!this.search) return this.asignadas;
      const term = this.search.toLowerCase();
      return this.asignadas.filter((s) =>
        s.sucursal.nombre.toLowerCase().includes(term)
      );
    },
    noAsignadasFiltradas() {
      if (!this.search) return this.noAsignadas;
      const term = this.search.toLowerCase();
      return this.noAsignadas.filter((s) =>
        s.nombre.toLowerCase().includes(term)
      );
    },
    totalAsignadas() {
      return this.asignadas.length;
    },
    totalSucursales() {
      return this.totalAsignadas + this.noAsignadas.length;
    },
  },
  methods: {
    async asignarProductoSucursal(sucursal) {
      try {
        const data = {
          producto_id: this.productoProp.id,
          sucursal_id: sucursal.id,
        };

        const response = await ProductosAPI.asignar(data);

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: "Producto asignado correctamente",
          icon: "mdi-check",
          timeout: 2000,
        });

        // Si querés actualizar algo luego
        this.$emit("refresh-producto");
      } catch (error) {
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "error",
          text: "Error al asignar el producto",
          icon: "mdi-alert-circle",
          timeout: 2000,
        });
      }
    },
    async desAsignarProductoSucursal(sucursal) {
      console.log(sucursal);

      try {
        const data = {
          producto_id: this.productoProp.id,
          sucursal_id: sucursal.sucursal.id,
        };

        const response = await ProductosAPI.desasignar(data);

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: "Producto desasignado correctamente",
          icon: "mdi-check",
          timeout: 2000,
        });

        // Si querés actualizar algo luego
        this.$emit("refresh-producto");
      } catch (error) {
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "error",
          text: "Error al desasignar el producto",
          icon: "mdi-alert-circle",
          timeout: 2000,
        });
      }
    },

    goToEdit(sucursal) {
      this.$router.push({
        name: "editProductoSucursal",
        params: {
          uuid_sucursal: sucursal.sucursal.uuid,
          uuid_empresa: this.$route.params.uuid_empresa,
          id_producto_sucursal: sucursal.id,
        },
      });
    },
  },
};
</script>

<style scoped>
.v-toolbar {
  padding-left: 0 !important;
}
</style>
